import styled from "@emotion/styled";

export const BreadcrumbContainer = styled.div`
  display: flex;
  place-items: center;
  gap: ${({ theme }) => theme.space.space4};
`;

export const BreadcrumbItem = styled.div`
  display: flex;
  min-height: ${({ theme }) => theme.fontSizes.fontSize20};
  font-size: ${({ theme }) => theme.fontSizes.fontSize14};
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};

  a {
    color: ${({ theme }) => theme.colors.tone.anthraciteLight};

    &:hover {
      color: ${({ theme }) => theme.colors.tone.black};
    }
  }
`;
